import React from 'react';

/** Compass-rose motif with three wind-colored points. viewBox -60..60. */
export function SeedPaths() {
  return <g data-id="element-230" data-mp="2dnlpuq9ebbku">
      <circle r={46} fill="none" stroke="#7FC4C0" strokeWidth={3} opacity={0.8} data-id="element-231" data-mp="2dnc0n4w6d8g7" />
      <circle r={34} fill="none" stroke="#14365D" strokeWidth={1.5} opacity={0.5} data-id="element-232" data-mp="2iklxh5lw8me2" />
      {[0, 90, 180, 270].map(a => <path key={a} d="M0 -52 L9 0 L0 8 L-9 0 Z" fill={a === 0 ? '#F28C28' : '#14365D'} transform={`rotate(${a})`} data-id="element-233" data-mp="2ndwt0al99gqo" />)}
      {[45, 135, 225, 315].map(a => <path key={a} d="M0 -34 L6 0 L0 5 L-6 0 Z" fill="#7FC4C0" transform={`rotate(${a})`} data-id="element-234" data-mp="2wc8td4bxbswb" />)}
      <circle r={7} fill="#E2574C" data-id="element-235" data-mp="31bv4974a4x1y" />
      <circle r={3} fill="#FBFAF6" data-id="element-236" data-mp="31cwgvg0y1rls" />
    </g>;
}
export function Seed({
  className = ''
}: {
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="-60 -60 120 120" className={className} data-id="element-237" data-mp="16y3rvzukfz2t">
      <SeedPaths data-id="element-238" data-mp="1706rnblit6kq" />
    </svg>;
}